var advisorop;
(function (advisorop) {
    var components;
    (function (components) {
        var advisor;
        (function (advisor) {
            class AdvisorNavBfeController {
                constructor(identityService, advisorService, generalService, $rootScope) {
                    this.identityService = identityService;
                    this.advisorService = advisorService;
                    this.generalService = generalService;
                    this.$rootScope = $rootScope;
                    this.user = {};
                    this.currentAdvisor = {};
                    this.adminModeAvailable = false; // only if user is Advisory Admin
                    this.adminModeEnabled = false;
                    this.advisoryFirms = null;
                    this.true = true;
                    this.$rootScope.$on('alertCounterChanged', (event) => {
                        this.counters = this.generalService.getAlertCounters();
                    });
                    //this.identityService.getUserPromise().then(response => {
                    //    this.user = response;
                    //});
                    this.sparklineData = {
                        chart: { caption: "", numberPrefix: "", subCaption: "", theme: "" },
                        data: []
                    };
                    this.advisoryTypeSystemLogin = advisorop.domains.SystemLoginType.ADVISOR;
                    this.servicerTypeSystemLogin = advisorop.domains.SystemLoginType.SERVICER;
                    this.advisoryRole = advisorop.domains.AdvisoryRoles.ADVISORY.toString();
                }
                logout() {
                    this.$router.parent.navigate(["Account", "Logout"]);
                }
                setAdminMode(adminModeEnabled, advisoryFirm) {
                    if (adminModeEnabled != null && adminModeEnabled != undefined) {
                        // adminMode must be available ...
                        this.adminModeEnabled = adminModeEnabled && this.adminModeAvailable;
                        let adminMode = {
                            enabled: this.adminModeEnabled /*&& !!advisoryFirm*/,
                            advisoryFirm: !!advisoryFirm ? advisoryFirm : { id: null }
                        };
                        this.advisorService.setAdminMode(adminMode);
                        //broadcast message admin mode is changed
                        this.$rootScope.$broadcast("adminModeChanged");
                        console.log("Admin mode is changed. Enabled = ", this.adminModeEnabled);
                    }
                }
                bindAdminMode() {
                    let adminMode = this.advisorService.getAdminMode();
                    // this will always be a ENABLED if AdminMode is available
                    this.adminModeEnabled = /*!!this.adminModeAvailable; /*/ !!adminMode.enabled;
                    this.selAdvisoryFirm = adminMode.advisoryFirm;
                }
                // #region TESTING functions
                testDocuSign() {
                    this.advisorService.ds_logininformation()
                        .then(response => {
                        console.log(`Success: ${response.status} : ${response.data}`);
                    })
                        .catch(response => {
                        console.log(`${response.status} : ${response.data}`);
                    });
                }
                ;
                testLaserApp() {
                    toastr.warning("This function is disabled.");
                    return;
                    //if (this.laserAppWnd) {
                    //    this.laserAppWnd.close();
                    //    this.laserAppWnd = null;
                    //}
                    //var formGuid = "{C1205DC0-78A7-407D-9959-9E74EC5A7541}";
                    //formGuid = window.prompt("Enter LaserAPP form guid", formGuid);
                    //this.advisorService.testLaserApp(formGuid)
                    //    .then(response => {
                    //        console.log("Response from LaserApp test:", response);
                    //        this.laserAppWnd = window.open(response.data, "_blank");
                    //    }
                    //    , err => this.generalService.showError(err));
                }
                ;
                openPPReport(report) {
                    if (!this.ppRepWindow) {
                        this.ppRepWindow = window.open("/samlidp/openppreport/0/HH/" + report, "_blank");
                        if (!this.ppRepWindow) {
                            toastr.warning("Your browser blocking popups from this site! Please enable popups for AdvisorOp!");
                        }
                    }
                    else {
                        this.ppRepWindow.location.href = "/samlidp/openppreport/0/HH/" + report;
                        this.ppRepWindow.focus();
                    }
                }
                // #endregion
                $onInit() {
                    //this.advisorService.getMarketValueByAdvisor().success((data) => {
                    //    this.sparklineData = data;
                    //}, err => this.generalService.showError(err));
                    this.identityService.getUserPromise().then(response => {
                        this.user = response;
                        this.adminModeAvailable = false;
                        if (this.user.advisor && this.user.advisor.id > 0) {
                            this.currentAdvisor = this.user.advisor;
                            // Advisory admins get the admin role unless they are being impersonated... then no admin role will be available
                            this.adminModeAvailable = (this.user.role.indexOf("ADVISORY_ADMIN") >= 0 && this.user.impersonated == false);
                            this.advisoryFirms = this.currentAdvisor.advisoryFirms;
                        }
                        this.bindAdminMode();
                    });
                    this.generalService.refreshAlertCounters();
                }
                $routerOnActivate(next, previous) {
                }
            }
            AdvisorNavBfeController.$inject = ["identityService", "advisorService", "generalService", "$rootScope"];
            class AdvisorNavBfe {
                constructor() {
                    this.bindings = {
                        "$router": "<"
                    };
                    this.controller = AdvisorNavBfeController;
                    this.controllerAs = "vm";
                    this.templateUrl = 'spa/advisor-module/components/advisor-nav-bfe.html';
                }
            }
            angular.module(advisorop.Constants.APP).component("advisorNavBfe", new AdvisorNavBfe());
        })(advisor = components.advisor || (components.advisor = {}));
    })(components = advisorop.components || (advisorop.components = {}));
})(advisorop || (advisorop = {}));
